import { Stack, Button } from "@mui/material";
import { FlexLoadingBlock } from "@synota-io/synota-shared-ui";
import { CONTRACTS_PATH } from "../../../../paths";
import { SearchStateLink } from "../../../../shared/layout/SearchStateLink";

export const LoadingContractBlock = ({ isLoading }: { isLoading: boolean }) => {
  return (
    <FlexLoadingBlock
      error={
        !isLoading && (
          <Stack alignItems="center">
            <span>Contract not found.</span>

            <Button component={SearchStateLink} to={CONTRACTS_PATH} size="small">
              Back to Contracts
            </Button>
          </Stack>
        )
      }
    >
      Loading Contract...
    </FlexLoadingBlock>
  );
};
